import { constants } from "@/constants";
import { routes } from "@/router";
import { useTranslation } from "react-i18next";
import { HiOutlineArrowRight } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

import Button from "@/components/atoms/Button";
import TimelineItem from "@/components/atoms/TimelineItem";

type Props = {
  className?: string;
  showCreateButton?: boolean;
};

const PredictiveLeadsIntro = ({ className = "mx-auto max-w-3xl py-24 space-y-8", showCreateButton = true }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={className}>
      <div className={"mx-auto max-w-xl text-center"}>
        <h1 className={"mb-3 text-2xl font-semibold text-primary"}>{t("predictive.intro.headline")}</h1>
        <p className={"text-sm text-quaternary"}>{t("predictive.intro.description")}</p>
      </div>

      <iframe
        src="https://www.youtube.com/embed/3sfxmMBn6PU?si=77Ta3ZC6FKZ5IkEn&amp;controls=0"
        width="100%"
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        className={"aspect-video rounded-xl shadow-xs"}
        allowFullScreen
      />

      <div className={"mx-auto max-w-xl"}>
        {showCreateButton && (
          <div className={"flex items-center justify-center pb-8 pt-4"}>
            <Button
              label={t("predictive.product.createFirst")}
              trailingIcon={<HiOutlineArrowRight className={"size-5"} />}
              onClick={() => navigate(routes.product.create)}
            />
          </div>
        )}

        <ol className="relative pt-1">
          {Array.from({ length: 7 }).map((_, index) => (
            <TimelineItem
              key={index}
              step={index + 1}
              title={t(`predictive.intro.steps.step${index + 1}.title`)}
              children={<p>{t(`predictive.intro.steps.step${index + 1}.description`)}</p>}
            />
          ))}
        </ol>

        {showCreateButton && (
          <>
            <p className={"mt-4 pb-3 text-sm font-medium text-quaternary"}>{t("predictive.intro.letsgo")} </p>

            <Button
              label={t("predictive.product.createFirst")}
              trailingIcon={<HiOutlineArrowRight className={"size-5"} />}
              onClick={() => navigate(routes.product.create)}
            />
          </>
        )}
      </div>

      <div className={"mx-auto max-w-xl rounded-2xl bg-secondary p-6 text-center shadow-xs"}>
        <div className={"mx-auto flex max-w-xl flex-col gap-2"}>
          <h3 className={"font-semibold text-primary"}>{t("predictive.intro.banner.title")}</h3>
          <p className={"text-sm text-quaternary"}>{t("predictive.intro.banner.description")}</p>
          <a
            href={`mailto:${constants.supportMail}`}
            className={"text-sm font-medium text-brand-primary hover:text-brand-primary-hover"}
          >
            {constants.supportMail}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PredictiveLeadsIntro;
